import type { TFunction } from 'i18next'

export interface AgentSuggestion {
  title: string
  prompt: string
}

export interface AgentWelcomeText {
  title: string
  description: string
}

const SUGGESTION_KEYS: Record<string, string[]> = {
  overview: ['summarize', 'keyPeople', 'investigateNext'],
  documents: ['findKey', 'financial', 'dates'],
  graph: ['connected', 'moneyFlows', 'shortestPath'],
  insights: ['patterns', 'relationships', 'timeline'],
  'entity-resolution': ['summarize'],
  lake: ['searchByContent', 'findByFilename', 'findByFolder'],
  default: ['help', 'summarize', 'keyEntities'],
}

function viewKey(currentView?: string): string {
  switch (currentView) {
    case 'overview':
    case 'documents':
    case 'insights':
    case 'lake':
    case 'entity-resolution':
      return currentView
    case 'graph':
    case 'explore':
      return 'graph'
    default:
      return 'default'
  }
}

export function getSuggestionsForView(t: TFunction, currentView?: string): AgentSuggestion[] {
  const view = viewKey(currentView)
  return SUGGESTION_KEYS[view].map(key => ({
    title: t(`agentSidebar.suggestions.${view}.${key}.title`),
    prompt: t(`agentSidebar.suggestions.${view}.${key}.prompt`),
  }))
}

export function getWelcomeTextForView(t: TFunction, currentView?: string): AgentWelcomeText {
  const view = viewKey(currentView)
  const welcomeKey = view === 'default' ? 'default' : view
  return {
    title: t(`agentSidebar.welcome.${welcomeKey}.title`),
    description: t(`agentSidebar.welcome.${welcomeKey}.description`),
  }
}

/** Map an `AgentScope` to the `currentView` value used by the welcome and
 * suggestion lookups. Lake scope always uses the `'lake'` bucket regardless
 * of which sub-route the user is on — folder/document awareness is
 * deferred to a future iteration. */
export function viewKeyForScope(scope: 'case' | 'lake', currentView?: string): string {
  return scope === 'lake' ? 'lake' : (currentView ?? 'default')
}
